import TermsAndConditionsService from '@/service/TermsAndConditionsService';
import { defineStore } from 'pinia';

export const useTermsAndConditionsStore = defineStore('termAndCondition', {
  state: () => {
    return {
      package: {},
      hotel_only: {},
      air_only: {},
      cruise: {}
    };
  },
  actions: {
    async getData(tab: string, type: string) {
      const Service = new TermsAndConditionsService();
      const res = await Service.getData(tab, type);
      return res?.data;
    },
    async updateData(payload: any) {
      const Service = new TermsAndConditionsService();
      const res = await Service.updateData(payload);
      return res?.data;
    },
    getBookingTermsAndConditions(type: string) {
      const Service = new TermsAndConditionsService();
      return Service.getBookingTermsAndConditions(type);
    },
    saveBookingTermAndCondition(payload: any) {
      const Service = new TermsAndConditionsService();
      return Service.saveBookingTermAndCondition(payload);
    }
  }
});
